import { GradientText } from 'src/common';
import styled from 'styled-components';

export const QAItem = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  user-select: none;
  flex-wrap: nowrap;

  * {
    text-align: right;
  }

  img,
  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ActionText = styled(GradientText)`
  font-size: 14px;
  font-weight: 500;
  text-transform: none;
  text-decoration: underline;
  white-space: nowrap;
`;
